module.exports = __webpack_public_path__ + "img/search.3fd9ea2a.svg";